import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GiftsToFamily as SectionKey } from 'Consts/Questionnaire';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import FieldList from '../Fields/FieldList';
import Section from '../Section';
import CurrencyInput from '../Fields/CurrencyInput';
import TextInput from '../Fields/TextInput';
import RadioInput from '../Fields/RadioInput';

class GiftToFamilyForm extends Component {
  static toTitleCase(str) {
    return str.replace(
      /\w*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      toWhom: '',
      frequency: '',
    };
    this.ref1 = React.createRef();
    this.handleToWhomChange = this.handleToWhomChange.bind(this);
    this.handleFrequencyChange = this.handleFrequencyChange.bind(this);
  }

  get title() {
    const { toWhom, frequency } = this.state;
    if (!toWhom || !frequency) {
      return '';
    }
    return `${toWhom} - ${frequency}`;
  }

  handleToWhomChange(key, val) {
    this.setState({ toWhom: val });
  }

  handleFrequencyChange(key, val) {
    this.setState({ frequency: GiftToFamilyForm.toTitleCase(val) });
  }

  render() {
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={this.title || 'New gift'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          name={`giftToFamilyToWhom.${id}`}
          answerKey="giftToFamilyToWhom"
          placeholder="To whom?"
          onChange={this.handleToWhomChange}
        />
        <CurrencyInput
          name={`giftToFamilyAmount.${id}`}
          answerKey="giftToFamilyAmount"
          placeholder="Amount of gift"
        />
        <RadioInput
          label="Frequency of gift"
          name={`giftToFamilyFrequency.${id}`}
          answerKey="giftToFamilyFrequency"
          onChange={this.handleFrequencyChange}
          options={[
            { id: 'one-time', text: 'One-Time' },
            { id: 'monthly', text: 'Monthly' },
            { id: 'annually', text: 'Annually' },
            { id: 'other', text: 'Other', showWhileSelected: this.ref1 },
          ]}
        />
        <TextInput
          name={`giftToFamilyOther.${id}`}
          answerKey="giftToFamilyOther"
          placeholder="Other"
          ref={this.ref1}
        />
      </LabeledVerticalExpander>
    );
  }
}

GiftToFamilyForm.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

GiftToFamilyForm.defaultProps = {
  expanded: false,
};

const GiftsToFamilySection = ({ isLastSection }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      title="Gifts to family"
      isLastSection={isLastSection}
      sectionKey={SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <p>Do you have gifts you give to family?</p>
      <FieldList
        onCountUpdate={setCount}
        label="Gifts"
        addLabel="Add gift"
        keyPrefix="giftToFamily"
        Of={GiftToFamilyForm}
      />
    </Section>
  );
};

GiftsToFamilySection.propTypes = {
  isLastSection: PropTypes.bool,
};

GiftsToFamilySection.defaultProps = {
  isLastSection: false,
};

export default GiftsToFamilySection;
